
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import PPMori from "../assets/fonts/PPMori-Regular.otf"; 
import Google from "../components/Icon/Google";
import NextArrow from "../components/Icon/NextArrow";
import Logo from "../components/Icon/Logo";
import Image from "../assets/images/banner.png";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { useData } from "../context/DataProvider";
import Loader from "../components/Loader";

import { isSignInWithEmailLink, sendSignInLinkToEmail, signInWithEmailLink } from "firebase/auth";
import { auth } from "../firebase";
import { cosmeticIQApi } from "../service/api";


function Login() {
  const [formData, setFormData] = useState({
    email: "",

  });
  const [emailText,setEmailText] = useState('')
  const {setIsAuthenticated,login,isAuthenticated} = useData();
  const [loading, setLoading] = useState(false);
  const [error,setError] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
  if (isAuthenticated) return navigate('/');

  if (isSignInWithEmailLink(auth, window.location.href)) {
    const email = localStorage.getItem("emailForSignIn");
    
    signInWithEmailLink(auth, email, window.location.href)
      .then(() => {
        cosmeticIQApi.updateUserSignIn(email);

        localStorage.removeItem("emailForSignIn");
        localStorage.setItem('loginTime', Date.now().toString());

        
        setIsAuthenticated(true);
      })
      .catch((err) => console.error("Error signing in with email link", err));
  }
}, [isAuthenticated, navigate]);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setEmailText("")
    setError("")
    if(!formData.email )
      {setError("All fields are required")
    return}
    setLoading(true);
    if (!formData.email) {
      setLoading(false);
      return;
    }
    try {
      const response = await login(formData)
      
      if(response.error)

        setError(response.error)
      else{
  setLoading(false);
  sendSignInLinkToEmail(auth,formData.email,{
    url: process.env.REACT_APP_FRONTEND_URL,
    handleCodeInApp:true
  }).then(()=>
  {
    setEmailText("Please check your email for a link to login")
    localStorage.setItem('emailForSignIn', formData.email);
    
}
  )
  
  
      }
      

    } catch (error) {
       
      console.error(error);
      setLoading(false);
    }
    setLoading(false);
  };
  const loginResponse = useGoogleLogin({
    onSuccess: async (response) => {
      setEmailText("")
      setError("")
     setLoading(true)
        try {
          const userInfo = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
            headers: {
              Authorization: `Bearer ${response.access_token}`
            }
          });
          
          const userData = await userInfo.json();
          
          const data = {
            email:userData.email,
            googleAuth:true

          }
          const loginResponse = await login(data)
          
          if(loginResponse.error)
    
            setError(loginResponse.error)
          else{
            setLoading(false);
            sendSignInLinkToEmail(auth,userData.email,{
              url: process.env.REACT_APP_FRONTEND_URL,
              handleCodeInApp:true
            }).then(()=>
            {
          
              setEmailText("Please check your email for a link to login")
              
              
              
              localStorage.setItem('emailForSignIn', loginResponse.user.email);
          
          
          
          })
        }
          setLoading(false)
    
        } catch (error) {
           
          console.error(error);
          setLoading(false);
        }
      
    },
    onError: (error) => {
      console.error('Login Failed:', error);
    }
  });
  return (
    <Container style={{display:'flex',flexDirection:'row'}}>
    <AppContainer>
      <FormWrapper>
        <LogoArea>
    <Logo/>
</LogoArea>
<TitleArea>
        <Title>Enter your account</Title>
        </TitleArea>
        <Form onSubmit={handleSubmit}>
        
          <FullInput
            type="email"
            name="email"
            placeholder="Email address"
            value={formData.email}
            onChange={handleChange}
          />
        
         
         
          <SubmitButton disabled={loading || !formData.email} type="submit">
           {
            loading ? <Loader/> :
            <> <LoginTxt>LOG IN</LoginTxt> <NextArrow/></>}</SubmitButton>
            {error && <Subtext style={{color:"red"}}>
          {error} 
        </Subtext>}
        {emailText && <Subtext style={{color:"green"}}>
          {emailText} 
        </Subtext>}
        </Form>
        <OrArea>
        <OrText>OR LOGIN WITH </OrText>
        <GoogleButton onClick={loginResponse}>
        <Google/>
        </GoogleButton> 
        </OrArea>
      </FormWrapper>
    </AppContainer>
    <SideCover alt="cover"  src={Image}/>
    </Container>
  );
}

export default Login;



const AppContainer = styled.div`
  font-family: Arial, sans-serif;
  
  display: flex;
  justify-content: center;
  
  height: 100vh;
  width:50%;
`;

const FormWrapper = styled.div`
height:100%;
display:flex;
flex-direction:column;
justify-content:space-around;

`;

const LoginTxt = styled.p``

const Title = styled.h1`
  
  font-family: 'PP Mori';
font-size: 48px;
font-weight: 600;
line-height: 52.8px;
letter-spacing: -0.01em;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#2F3237;

`;


const Subtext = styled.p`
font-family: 'PP Mori';
font-size: 16px;
font-weight: 500;
line-height: 19.2px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#2F323799

`;



const Form = styled.form`

display:flex;
gap: 10px;
flex-direction:column;

opacity: 0px;

`;

const FullInput = styled.input`
 @font-face {
    font-family: 'PP Mori';
    src: url(${PPMori}) format('truetype');
   
  }
  font-family: 'PP Mori';

padding: 12px;

border:none;
gap: 8px;
border-radius: 12px;
opacity: 0px;
background:#F9F9F9;

font-size: 14px;
font-weight: 600;
line-height: 16.8px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#20232799;

`;

const SideCover  = styled.img`
width:50%;
`



const SubmitButton = styled.button`
  background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);

height: 48px;
padding: 6px 14px 6px 14px;
gap: 8px;
border-radius: 64px;
opacity: 0px;
border:none;
cursor:pointer;


font-size: 12px;
font-weight: 800;
line-height: 14.4px;
letter-spacing: -0.01em;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#2F3237;
display:flex;
justify-content:center;

align-items:center;
text-align:center;



`;
const OrArea = styled.div`
gap:14px;
display:flex;
flex-direction:row;
align-items:center;
padding-bottom:50px;
`
const OrText = styled.p`


font-size: 14px;
font-weight: 700;
 line-height: 16.8px;
 letter-spacing: -0.01em;
 padding-top:10px;

 text-underline-position: from-font;
 text-decoration-skip-ink: none;
 

`;
const GoogleButton = styled.button`
border:none;
cursor:pointer;
background:#FFFFFF;
align-items:center;
display:flex;
`
const Container = styled.div``
const LogoArea = styled.div`
padding-top:50px;
`
const TitleArea= styled.div``
